module.exports = __webpack_public_path__ + "static/media/almac.4f744930.png";